import React from "react";

interface Props {}

function NotFound(props: Props) {
  return <div>not found</div>;
}

export default NotFound;
